import React, { Component } from 'react';
import { Switch, Form, Input, Button, Spin, InputNumber, Alert } from 'antd';
import { fetchData } from '../../../../lib/apis';

export default class AIChatbotSetting extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            config: null,
            saving: false,
            clearingCache: false
        };
    }

    componentDidMount() {
        this.loadConfig();
    }

    getProductCatalogTool = (config = {}) => {
        const productCatalog = config?.tools?.product_catalog || {};
        return {
            enabled: productCatalog.enabled !== false,
            max_items: productCatalog.max_items || 5
        };
    };

    loadConfig = async () => {
        try {
            this.setState({ loading: true });
            const res = await fetchData({
                url: `api/v1/app/ai/config?company_id=${this.props.companySelected?.company_id || 0}`
            });

            // Lấy persona defaults từ RAG service nếu công ty chưa custom
            let ragDefaults = {
                agent_name: 'Trợ lý AI',
                agent_role: 'Chuyên viên tư vấn',
                agent_personality: 'Thân thiện, nhiệt tình, chuyên nghiệp',
                response_style: 'Rõ ràng, dễ hiểu',
                greeting_style: '',
                restrictions: ''
            };

            // Gọi RAG API lấy config nếu có api_url
            const apiUrl = res.data?.api_url || 'https://rag.fumeesoft.com/retrieval/query';
            if (apiUrl) {
                try {
                    const ragConfigUrl = apiUrl.replace('/query', '/config');
                    const ragResponse = await fetch(`${ragConfigUrl}?companyId=${this.props.companySelected?.company_id || 0}`);
                    const ragRes = await ragResponse.json();
                    if (ragRes?.data) {
                        ragDefaults = {
                            agent_name: ragRes.data.agentName || ragDefaults.agent_name,
                            agent_role: ragRes.data.agentRole || ragDefaults.agent_role,
                            agent_personality: ragRes.data.agentPersonality || ragDefaults.agent_personality,
                            response_style: ragRes.data.responseStyle || ragDefaults.response_style,
                            greeting_style: ragRes.data.greetingStyle || ragDefaults.greeting_style,
                            restrictions: ragRes.data.restrictions || ragDefaults.restrictions
                        };
                    }
                } catch (ragErr) {
                    console.log('[AIChatbot] Could not fetch RAG defaults:', ragErr.message);
                }
            }

            this.setState({
                config: res.data,
                loading: false
            });
            const productCatalogTool = this.getProductCatalogTool(res.data);
            if (this.formRef) {
                this.formRef.setFieldsValue({
                    enabled: res.data?.enabled || false,
                    api_url: res.data?.api_url || 'https://rag.fumeesoft.com/retrieval/query',
                    welcome_message: res.data?.welcome_message || '',
                    ai_welcome_message: res.data?.ai_welcome_message || '',
                    button_text: res.data?.button_text || '',
                    timeout_minutes: res.data?.timeout_minutes || 30,
                    // Agent Persona - ưu tiên config công ty, fallback sang RAG defaults
                    agent_name: res.data?.agent_name || ragDefaults.agent_name,
                    agent_role: res.data?.agent_role || ragDefaults.agent_role,
                    agent_personality: res.data?.agent_personality || ragDefaults.agent_personality,
                    response_style: res.data?.response_style || ragDefaults.response_style,
                    greeting_style: res.data?.greeting_style || ragDefaults.greeting_style,
                    restrictions: res.data?.restrictions || ragDefaults.restrictions,
                    tool_product_catalog_enabled: productCatalogTool.enabled,
                    tool_product_catalog_max_items: productCatalogTool.max_items
                });
            }
        } catch (err) {
            this.setState({ loading: false });
            this.props.notification?.({
                title: "Lỗi",
                content: err.message || "Không thể tải cấu hình AI",
                type: "error"
            });
        }
    };

    saveConfig = async (values) => {
        try {
            this.setState({ saving: true });
            const payload = {
                ...values,
                tools: {
                    product_catalog: {
                        enabled: values.tool_product_catalog_enabled !== false,
                        max_items: values.tool_product_catalog_max_items || 5,
                        match_mode: 'keyword'
                    }
                }
            };
            delete payload.tool_product_catalog_enabled;
            delete payload.tool_product_catalog_max_items;

            await fetchData({
                url: `api/v1/app/ai/config`,
                method: 'put',
                data: {
                    company_id: this.props.companySelected?.company_id || '0',
                    ...payload
                }
            });
            this.setState({ saving: false });
            this.props.notification?.({
                title: "AI Chatbot",
                content: "Lưu cấu hình thành công!"
            });
        } catch (err) {
            this.setState({ saving: false });
            this.props.notification?.({
                title: "Lỗi",
                content: err.message || "Không thể lưu cấu hình",
                type: "error"
            });
        }
    };

    clearCache = async () => {
        try {
            this.setState({ clearingCache: true });
            await fetchData({
                url: `api/v1/app/ai/cache?company_id=${this.props.companySelected?.company_id || 0}`,
                method: 'delete'
            });
            this.setState({ clearingCache: false });
            this.props.notification?.({
                title: "AI Chatbot",
                content: "Đã xóa cache thành công!"
            });
        } catch (err) {
            this.setState({ clearingCache: false });
            this.props.notification?.({
                title: "Lỗi",
                content: err.message || "Không thể xóa cache",
                type: "error"
            });
        }
    };

    render() {
        return (
            <div style={{ padding: "20px", background: "#fafafa" }}>
                <Spin spinning={this.state.loading}>
                    <Alert
                        message="AI Chatbot Tự động"
                        description="Khi bật tính năng này, nếu không có nhân viên Sales trong ca làm việc, khách hàng sẽ nhận được tin nhắn mời sử dụng AI tư vấn tự động."
                        type="info"
                        showIcon
                        style={{ marginBottom: 20 }}
                    />
                    
                    <Form
                        ref={(ref) => this.formRef = ref}
                        layout="vertical"
                        onFinish={this.saveConfig}
                        initialValues={{
                            enabled: false,
                            api_url: 'https://rag.fumeesoft.com/retrieval/query',
                            welcome_message: 'Xin chào! Hiện không có nhân viên, bạn muốn tư vấn bằng AI không?',
                            ai_welcome_message: 'Chào bạn! Tôi là trợ lý AI. Bạn có câu hỏi gì cần tư vấn không?',
                            button_text: 'Tư vấn bằng AI',
                            timeout_minutes: 30
                        }}
                    >
                        <Form.Item 
                            name="enabled" 
                            label="Bật AI Chatbot"
                            valuePropName="checked"
                        >
                            <Switch 
                                checkedChildren="Bật" 
                                unCheckedChildren="Tắt"
                            />
                        </Form.Item>

                        <Form.Item 
                            name="api_url" 
                            label="API URL (RAG Service)"
                            rules={[
                                { required: true, message: 'Vui lòng nhập URL API' }
                            ]}
                            extra="Ví dụ: https://rag.fumeesoft.com/retrieval/query"
                        >
                            <Input placeholder="https://rag.fumeesoft.com/retrieval/query" />
                        </Form.Item>

                        <Form.Item 
                            name="welcome_message" 
                            label="Tin nhắn chào mừng"
                            rules={[
                                { required: true, message: 'Vui lòng nhập tin nhắn' }
                            ]}
                        >
                            <Input.TextArea 
                                rows={3}
                                placeholder="Tin nhắn sẽ gửi cho khách hàng khi không có Sales"
                            />
                        </Form.Item>

                        <Form.Item 
                            name="button_text" 
                            label="Text nút xác nhận"
                            rules={[
                                { required: true, message: 'Vui lòng nhập text nút' }
                            ]}
                        >
                            <Input placeholder="Tư vấn bằng AI" />
                        </Form.Item>

                        <Form.Item 
                            name="ai_welcome_message" 
                            label="Tin nhắn AI chào mừng"
                            extra="Tin nhắn gửi sau khi khách nhấn nút xác nhận, bắt đầu chế độ AI"
                            rules={[
                                { required: true, message: 'Vui lòng nhập tin nhắn' }
                            ]}
                        >
                            <Input.TextArea 
                                rows={3}
                                placeholder="Chào bạn! Tôi là trợ lý AI. Bạn có câu hỏi gì cần tư vấn không?"
                            />
                        </Form.Item>

                        <Form.Item 
                            name="timeout_minutes" 
                            label="Thời gian timeout (phút)"
                            extra="Sau khoảng thời gian này, session AI sẽ tự động kết thúc"
                        >
                            <InputNumber min={5} max={120} style={{ width: '100%' }} />
                        </Form.Item>

                        <div style={{ borderTop: '1px solid #e8e8e8', paddingTop: 20, marginTop: 20, marginBottom: 16 }}>
                            <h4 style={{ marginBottom: 16 }}>🧰 AI Tools</h4>
                            <p style={{ color: '#666', marginBottom: 16, fontSize: 13 }}>
                                Cho phép agent dùng danh mục sản phẩm của hệ thống khi tư vấn khách hàng. Nếu sản phẩm có ảnh, AI sẽ gửi kèm ảnh qua các channel hỗ trợ.
                            </p>
                        </div>

                        <Form.Item
                            name="tool_product_catalog_enabled"
                            label="Danh mục sản phẩm / Product Catalog"
                            valuePropName="checked"
                            extra="Bật để AI được phép truy cập danh sách sản phẩm làm nguồn trả lời"
                        >
                            <Switch />
                        </Form.Item>

                        <Form.Item
                            noStyle
                            shouldUpdate={(prevValues, currentValues) => prevValues.tool_product_catalog_enabled !== currentValues.tool_product_catalog_enabled}
                        >
                            {({ getFieldValue }) => getFieldValue('tool_product_catalog_enabled') ? (
                                <Form.Item
                                    name="tool_product_catalog_max_items"
                                    label="Số sản phẩm tối đa mỗi lần tra cứu"
                                    extra="Giới hạn số sản phẩm AI lấy vào ngữ cảnh để tránh trả lời quá dài"
                                >
                                    <InputNumber min={1} max={10} style={{ width: '100%' }} />
                                </Form.Item>
                            ) : null}
                        </Form.Item>

                        <div style={{ borderTop: '1px solid #e8e8e8', paddingTop: 20, marginTop: 20, marginBottom: 16 }}>
                            <h4 style={{ marginBottom: 16 }}>🤖 Định danh Agent</h4>
                            <p style={{ color: '#666', marginBottom: 16, fontSize: 13 }}>
                                Cá nhân hóa AI cho công ty của bạn. Các cài đặt này sẽ ảnh hưởng đến cách AI trả lời khách hàng.
                            </p>
                        </div>

                        <Form.Item 
                            name="agent_name" 
                            label="Tên AI"
                            extra="Ví dụ: Linh, Hoa, AI Assistant"
                        >
                            <Input placeholder="Trợ lý AI" />
                        </Form.Item>

                        <Form.Item 
                            name="agent_role" 
                            label="Vai trò"
                            extra="Chức danh/vị trí của AI"
                        >
                            <Input placeholder="Chuyên viên tư vấn" />
                        </Form.Item>

                        <Form.Item 
                            name="agent_personality" 
                            label="Tính cách"
                            extra="Mô tả phong cách giao tiếp"
                        >
                            <Input.TextArea 
                                rows={2}
                                placeholder="Thân thiện, nhiệt tình, chuyên nghiệp"
                            />
                        </Form.Item>

                        <Form.Item 
                            name="response_style" 
                            label="Phong cách trả lời"
                            extra="Hướng dẫn format câu trả lời"
                        >
                            <Input.TextArea 
                                rows={2}
                                placeholder="Ngắn gọn, dễ hiểu, có emoji khi phù hợp"
                            />
                        </Form.Item>

                        <Form.Item 
                            name="greeting_style" 
                            label="Cách chào hỏi"
                            extra="Phong cách mở đầu câu trả lời"
                        >
                            <Input placeholder="Luôn chào hỏi trước khi trả lời" />
                        </Form.Item>

                        <Form.Item 
                            name="restrictions" 
                            label="Hạn chế"
                            extra="Những điều AI không nên đề cập"
                        >
                            <Input.TextArea 
                                rows={2}
                                placeholder="Không đề cập đến đối thủ cạnh tranh, không cam kết giá cả"
                            />
                        </Form.Item>

                        <Form.Item>
                            <Button 
                                type="primary" 
                                htmlType="submit"
                                loading={this.state.saving}
                                style={{ marginRight: 10 }}
                            >
                                Lưu cấu hình
                            </Button>
                            <Button 
                                danger
                                onClick={this.clearCache}
                                loading={this.state.clearingCache}
                            >
                                Xóa Cache AI
                            </Button>
                        </Form.Item>
                    </Form>
                </Spin>
            </div>
        );
    }
}
